import { Navigate, useParams } from "react-router-dom";

/**
 * Rotte storiche dell'**Editor SLA** (`/dashboard/process/sla` e
 * `/dashboard/process/sla/:modelId`).
 *
 * La configurazione SLA vive ora nel designer del modello: sezione "SLA" del
 * pannello proprieta' (processo senza selezione, attivita' selezionata). Questa
 * rotta resta solo come redirect, cosi' la voce di menu e i deep link esistenti
 * continuano a funzionare: con il modello si apre il designer, senza si torna
 * ai Modelli.
 */
const SlaEditor = () => {
  const { modelId } = useParams<{ modelId?: string }>();

  return (
    <Navigate
      to={modelId ? `/dashboard/process/edit/${modelId}` : "/dashboard/process"}
      replace
    />
  );
};

export default SlaEditor;
